export const ERROR = 'error';
export const NO_INTERNET_CONNECTION = 'no_internet_connection';
